import { SWRConfiguration, SWRResponse } from "swr";

import { CachedTrialConfigurationSourceData, GetConfigurationSourceDataResponse, GetTrialConfigurationSourceData } from "@/api/dtos";
import useGet from "@/hooks/api/useGet";
import { useMemo } from "react";


const getData = (response?: SWRResponse<GetConfigurationSourceDataResponse, GetConfigurationSourceDataResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<GetConfigurationSourceDataResponse, GetConfigurationSourceDataResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<GetConfigurationSourceDataResponse, GetConfigurationSourceDataResponse>) => ({});

export const useTrialConfigurationSourceData = (trialId?: number, configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!trialId) {
            return undefined;
        }

        return () => {
            return new CachedTrialConfigurationSourceData({ trialId });
        }
    }, [trialId]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useTrialConfigurationSourceData;